import { render } from "./Calendar.vue?vue&type=template&id=42bc94e7&scoped=true"
const script = {}

import "./Calendar.vue?vue&type=style&index=0&id=42bc94e7&scoped=true&lang=css"

import exportComponent from "/Users/hank/winho/gx/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42bc94e7"]])

export default __exports__